module.exports = __webpack_public_path__ + "img/01n.42924fbf.png";